// Mapa edificio+nombre -> imagen, reutilizando los mismos assets que usan las
// pantallas públicas de reserva (Cards.js, Card2.js, Cards3.js, Cards4.js,
// Datas.js, Zonadescarga.js, Plazas.js), para que las cards del panel de
// administración (Gestión > Disponibilidad de Salas) se vean igual que las
// que ve el usuario.
//
// Se busca por edificio+nombre (no por id_Sala) porque el id hardcodeado en
// el frontend no siempre coincide con el id_Sala real de la base de datos.

// Torre 1
import t1Sala1 from "./assets/t1Sala1.jpg";
import t1Sala2 from "./assets/t1Sala2.jpg";
import t1Sala3 from "./assets/t1Sala3.jpg";
import t1Sala4 from "./assets/t1Sala4.jpg";
import t1Comedor from "./assets/t1Comedor.jpg";

// Torre 2
import t2Sala1 from "./assets/t2Sala1.jpg";
import t2Sala2 from "./assets/t2Sala2.jpg";
import t2Sala3 from "./assets/t2Sala3.jpg";
import t2Sala4 from "./assets/t2Sala4.jpg";
import t2Comedor from "./assets/T2Comedor.jpg";

// CBB
import cbbSala1 from "./assets/cbbSala1.jpg";
import cbbSala2 from "./assets/cbbSala2.jpg";
import cbbSala3 from "./assets/cbbSala3.jpg";
import cbbSala4 from "./assets/cbbSala4.jpg";
import cbbSala5 from "./assets/cbbSala5A.jpg";
import cbbComedor from "./assets/CBBComedorD.jpg";

// CBC
import cbcSala1 from "./assets/cbcSala1.jpg";
import cbcSala2 from "./assets/cbcSala2.jpg";
import cbcSala3 from "./assets/cbcSala3.jpg";
import cbcSala4 from "./assets/cbcSala4.jpg";
import cbcSala5 from "./assets/cbcSala5.jpg";
import cbcSala6 from "./assets/cbcSala6.jpg";
import cbcComedor from "./assets/cbcComedor.jpg";

// Data Center
import dataDefault from "./assets/DSCF1032.jpg";

// Zona de Descarga
import zonaDescarga from "./assets/zonaDescarga.jpg";

// Plaza
import etnias from "./assets/DSCF1688.jpg";
import democracia from "./assets/DSCF1602.jpg";

const normalizar = (valor) =>
  String(valor || "")
    .trim()
    .replace(/\s+/g, " ")
    .replace(/([A-Za-zÁÉÍÓÚáéíóú])(\d)/, "$1 $2")
    .toLowerCase();

const clave = (edificio, nombre) => `${normalizar(edificio)}|${normalizar(nombre)}`;

const mapaImagenes = {
  [clave("Torre 1", "Sala 1")]: t1Sala1,
  [clave("Torre 1", "Sala 2")]: t1Sala2,
  [clave("Torre 1", "Sala 3")]: t1Sala3,
  [clave("Torre 1", "Sala 4")]: t1Sala4,
  [clave("Torre 1", "Comedor")]: t1Comedor,

  [clave("Torre 2", "Sala 1")]: t2Sala1,
  [clave("Torre 2", "Sala 2")]: t2Sala2,
  [clave("Torre 2", "Sala 3")]: t2Sala3,
  [clave("Torre 2", "Sala 4")]: t2Sala4,
  [clave("Torre 2", "Comedor")]: t2Comedor,
  [clave("Torre 2", "Zona de Descarga")]: zonaDescarga,

  [clave("CBB", "Sala 1")]: cbbSala3,
  [clave("CBB", "Sala 2")]: cbbSala1,
  [clave("CBB", "Sala 3")]: cbbSala2,
  [clave("CBB", "Sala 4")]: cbbSala4,
  [clave("CBB", "Sala 5")]: cbbSala5,
  [clave("CBB", "Comedor")]: cbbComedor,

  [clave("CBC", "Sala 1")]: cbcSala1,
  [clave("CBC", "Sala 2")]: cbcSala2,
  [clave("CBC", "Sala 3")]: cbcSala3,
  [clave("CBC", "Sala 4")]: cbcSala4,
  [clave("CBC", "Sala 5")]: cbcSala5,
  [clave("CBC", "Sala 6")]: cbcSala6,
  [clave("CBC", "Comedor")]: cbcComedor,

  [clave("Data Center", "Sala Blanca 1")]: dataDefault,
  [clave("Data Center", "Sala Blanca 2")]: dataDefault,
  [clave("Data Center", "Sala Blanca 3")]: dataDefault,
  [clave("Data Center", "Cuarto de Proveedores")]: dataDefault,
  [clave("Data Center", "Visita General")]: dataDefault,

  [clave("Plaza", "Las 9 Etnias")]: etnias,
  [clave("Plaza", "La Democracia")]: democracia,
};

export function getSalaImagen(edificio, nombre) {
  return mapaImagenes[clave(edificio, nombre)];
}

export default getSalaImagen;
